var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_videos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consulta_de_videos",
    "data-name": "Consulta de videos"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.5 18.5 56.51 23.51 56.51 18.5 51.5 18.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.49 23.51 14.5 18.5 9.49 18.5 9.49 23.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.51 47.5 56.51 42.49 51.5 47.5 56.51 47.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.49 47.5 14.5 47.5 9.49 42.49 9.49 47.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.28.28a.4.4,0,0,0-.56,0L17,16H49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,59,26V40l6.71-6.71A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0L49,50H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.28,32.72a.4.4,0,0,0,0,.56L7,40V26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.49,18.5h5L17,16H7.39a.4.4,0,0,0-.4.4V26l2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.49,47.5v-5L7,40V49.6a.4.4,0,0,0,.4.4H17l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.51,47.5h-5L49,50h9.61a.4.4,0,0,0,.4-.4V40l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.51,18.5v5L59,26V16.4a.4.4,0,0,0-.4-.4H49l2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "56.51 23.51 56.51 42.49 59.01 39.99 59.01 26.01 56.51 23.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "9.49 23.51 6.99 26.01 6.99 39.99 9.49 42.49 9.49 23.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50,47.5v-29h1.5L49,16H17l-2.5,2.5H16v29H14.5L17,50H49l2.5-2.5Zm-2.5,0h-29v-29h29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.49,18.5v29h29v-29ZM41.38,33.35,33,38l-8.42,4.68a.4.4,0,0,1-.59-.35V23.67a.4.4,0,0,1,.59-.35L33,28l8.38,4.65A.4.4,0,0,1,41.38,33.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.38,32.65,33,28l-8.42-4.68a.4.4,0,0,0-.59.35V42.33a.4.4,0,0,0,.59.35L33,38l8.38-4.65A.4.4,0,0,0,41.38,32.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.49,
    y: 18.5,
    width: 6.5,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50,
    y: 18.5,
    width: 6.5,
    height: 29
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMVideos);
export default __webpack_public_path__ + "static/media/m_videos.14578df995a2042eec149fb1cd1be30b.svg";
export { ForwardRef as ReactComponent };